import { Box, Skeleton } from "@mui/material";
import { ChatProcess, ChatProcessStatus } from "../types/chat";

type ChatWaitingTopProps = {
    isLoadingSession: boolean;
    isPendingSession: boolean;
    assignProcess: ChatProcess;
}
const ChatWaitingTop: React.FC<ChatWaitingTopProps> = ({ isLoadingSession, isPendingSession, assignProcess }) => {
    if (isLoadingSession || assignProcess.status === ChatProcessStatus.PENDING) {
        return (<Box className="chatyme-alert-box" sx={{ padding: '6px 16px' }}>
            <Skeleton variant="text" sx={{ fontSize: '24px' }} />
        </Box>)
    }
    return null;
};

export default ChatWaitingTop;